module.exports = "<div class=\"usc-scheduler\">\n    <img src=\"../../../assets/img/usc-store-scheduling/usc_scheduling_logo.png\" />\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-scheduling/usc-store-scheduling.component.html
// module id = ../../../../../src/app/components/usc-store-scheduling/usc-store-scheduling.component.html
// module chunks = main